import { defineMessages } from 'react-intl-next';

const messagesBase = defineMessages({
	createTemplate: {
		id: 'snippets.createTemplate',
		defaultMessage: 'Create template',
		description: 'Label for the create template button in the contextual toolbar',
	},
	createTemplateLozenge: {
		id: 'snippets.createTemplateLozenge',
		defaultMessage: 'New',
		description: 'Lozenge label for the create template button in the contextual toolbar',
	},
	snippetBy: {
		id: 'snippets.quick-insert.by',
		defaultMessage: 'by {name}',
		description: 'Description text showing who created the snippet, with the creator name',
	},
});

export const messages = messagesBase;
